import {Record} from 'immutable';

import {NETWORK_STATUSES, type NetworkStatus} from './constants';

export const XHRStateRecord = Record({
  requestStatus: NETWORK_STATUSES.INIT,
}) as any;

const defaultXHRState = XHRStateRecord();

export type XHRState = typeof defaultXHRState & {
  requestStatus: NetworkStatus;
};

export const CommerceStripeRecord = Record({
  requestStatus: NETWORK_STATUSES.INIT,
  disconnectRequestStatus: NETWORK_STATUSES.INIT,
  url: null,
  connectionRequested: false,
}) as any;

export const defaultStripeState = CommerceStripeRecord();

export type CommerceStripeRecordType = typeof defaultStripeState & {
  requestStatus: NetworkStatus;
};
